module.exports = __webpack_public_path__ + "img/default_pic.c4e38541.png";